import React from "react";
import clsx from "classnames";
var TextField = function (_a) {
    var _b = _a.autoComplete, autoComplete = _b === void 0 ? true : _b, _c = _a.classes, classes = _c === void 0 ? "" : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.error, error = _e === void 0 ? false : _e, fullWidth = _a.fullWidth, _f = _a.helperText, helperText = _f === void 0 ? "" : _f, id = _a.id, _g = _a.inputComponent, inputComponent = _g === void 0 ? "input" : _g, _h = _a.inputProps, inputProps = _h === void 0 ? {} : _h, _j = _a.inputRef, inputRef = _j === void 0 ? null : _j, label = _a.label, name = _a.name, onBlur = _a.onBlur, 
    // Passing a value to a field without an onChange handler causes a warning
    // that you are creating a read-only field. Therefore, we'll ensure that
    // onChange has a default value
    _k = _a.onChange, 
    // Passing a value to a field without an onChange handler causes a warning
    // that you are creating a read-only field. Therefore, we'll ensure that
    // onChange has a default value
    onChange = _k === void 0 ? function () { } : _k, placeholder = _a.placeholder, pattern = _a.pattern, _l = _a.type, type = _l === void 0 ? "text" : _l, value = _a.value;
    var autoCompleteText = autoComplete;
    if (autoCompleteText === true) {
        autoCompleteText = "on";
    }
    else if (autoCompleteText === false) {
        autoCompleteText = "off";
    }
    var InputComponent = inputComponent;
    return (<div className={clsx("relative m-0 inline-flex min-w-0 flex-col border-0 p-0 align-top text-gray-500 transition-colors focus-within:text-blue-600", { "text-red-700": error }, { "w-full": fullWidth })} data-testid="outer-container">
      {label && (<label className={clsx("font-noto mb-2 p-0 text-left text-xs leading-none font-semibold", {
                "text-red-700": error,
                "text-gray-400": disabled && !error,
            })} htmlFor={id}>
          {label}
        </label>)}
      <div className={clsx("font-noto relative box-border inline-flex items-center overflow-hidden rounded-sm border border-solid bg-white font-normal focus-within:border-blue-600", classes, { "border-gray-400": !error }, { "border-red-700": error })} data-testid="input-container">
        <InputComponent autoComplete={autoCompleteText} className={clsx("font-inherit tracking-inherit relative m-0 box-content block h-5 w-full min-w-0 items-center border-0 bg-white bg-none px-3 py-2.5 text-base text-current", { "cursor-text text-gray-800": !disabled }, { "cursor-default text-gray-400": disabled })} disabled={disabled} id={id} {...inputProps} name={name} onBlur={onBlur} onChange={onChange} pattern={pattern} placeholder={placeholder} ref={inputRef} type={type} value={value}/>
      </div>
      {helperText && (<div className={clsx("font-noto mt-1 text-xs font-normal", {
                "text-red-700": error,
            })}>
          {helperText}
        </div>)}
    </div>);
};
export default TextField;
